import { useEffect, useState } from 'react';
import { message, Modal, Spin, Upload } from 'antd';
import { Description, Text, Title } from '@/components/atoms';
import { UploadFile } from 'antd/es/upload/interface';
import { UploadChangeParam } from 'antd/lib/upload';
import { read, readBytes, resize } from '@/utils/fileExtension';
import api from '@/api';
import { useHistory } from 'react-router-dom';
import { ErrorMessage } from '@/constants/message';

import { API_TAX_NOTICE, PATH_TAX_NOTICE_LIST } from '@/constants/constant';
import { useSelector } from 'react-redux';
import { RootState } from '@/rootReducer';

import { TaxTemplate } from '@/components/template';
import TaxNoticeUploadFooter from '@/components/organisms/tax/notice/upload/TaxNoticeUploadFooter';

const MAX_UPLOAD_FILE_COUNT = 20;

const TaxNoticeUploadPage = () => {
  const history = useHistory();
  const { current: company } = useSelector((state: RootState) => state.company);

  const [selectedKeySet, setSelectedKeySet] = useState<string[]>([]);

  const [images, setImages] = useState<UploadFile[]>([]);
  const [isPreviewVisible, setPreviewVisible] = useState(false);

  const [previewTitle, setPreviewTitle] = useState('');
  const [previewImage, setPreviewImage] = useState('');

  const [isConfirmVisible, setConfirmVisible] = useState(false);

  const [isLoading, setLoading] = useState(false);
  const [isProcessing, setProcessing] = useState(false);
  const [isExecutable, setExecutable] = useState(false);

  useEffect(() => {
    setSelectedKeySet(images.map((image) => image.uid));
  }, [images]);

  const onClickConfirm = async () => {
    setExecutable(false);
    setLoading(true);
    const files: any[] = [];
    const formData = new FormData();
    formData.append('companyId', company?.base.id);

    // eslint-disable-next-line no-restricted-syntax
    for (const image of images) {
      console.log(image.originFileObj?.type);
      // eslint-disable-next-line no-await-in-loop
      const data = await readBytes(image);

      console.log(data);
      files.push({ type: 'taxNotice', data });
    }

    console.log(images, files);

    api
      .post(API_TAX_NOTICE, 'ptax.PbTaxNoticeCreateRequest', {
        companyId: company?.base.id,
        file: files,
      })
      .then(() => {
        setImages([]);
        message.success('고지서 분석을 요청했습니다.');
        history.push(PATH_TAX_NOTICE_LIST);
      })
      .catch((e) => {
        const error = e?.response?.data;
        if (error) {
          message.error(error.message);
        } else {
          message.error(ErrorMessage.network.disconnected);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const onClickPreview = async (file: UploadFile) => {
    if (!file.url && !file.preview) {
      file.preview = await read(file);
    }
    setPreviewImage(file.url || file.preview || '');
    setPreviewTitle(file.name);
    setPreviewVisible(true);
  };

  useEffect(() => {
    setProcessing(false);
    setExecutable(images.length > 0 && images.every((image) => image.size > 0 && image.status === 'done'));
  }, [images]);

  return (
    <TaxTemplate className="notice upload">
      <Title>고지서 등록하기</Title>
      <Upload.Dragger
        className="ant-upload-drag-tax-notice"
        name="file"
        accept=".jpg, .jpeg, .png"
        multiple
        showUploadList={{
          showRemoveIcon: true,
          showPreviewIcon: true,
          removeIcon: <Text>삭제</Text>,
        }}
        beforeUpload={() => {
          setProcessing(true);
          return true;
        }}
        listType="picture"
        customRequest={(option) => {
          const { onSuccess } = option;
          if (onSuccess) {
            onSuccess({ status: 'done' }, new XMLHttpRequest());
          }
          // if (images.map((image) => image.fileName).includes(option.filename)) {
          //   option.onSuccess({ status: 'error', response: '중복된 파일' }, option.file);
          // } else {
          //   option.onSuccess({ status: 'done' }, option.file);
          // }
        }}
        fileList={images}
        transformFile={resize}
        onChange={({ fileList }: UploadChangeParam<UploadFile>) => {
          fileList.slice(MAX_UPLOAD_FILE_COUNT + 1, fileList.length).forEach((file) => {
            file.status = 'error';
            file.response = '파일 최대 개수 초과';
          });
          setImages(fileList.filter((image) => image.size > 0));
        }}
        onPreview={onClickPreview}
      >
        <Spin spinning={isProcessing} tip="처리중">
          <Title>고지서 파일을 이곳에 끌어 넣거나 클릭해주세요</Title>
          <Description>JPG 또는 PNG 파일만 등록할 수 있습니다</Description>
        </Spin>
      </Upload.Dragger>
      <TaxNoticeUploadFooter
        size={images.length}
        confirmable={isExecutable}
        loading={isLoading}
        onClickDeleteAll={() => {
          setImages([]);
        }}
        onClickConfirm={onClickConfirm}
      />
      <Modal visible={isPreviewVisible} title={previewTitle} footer={null} onCancel={() => setPreviewVisible(false)}>
        <img alt="preview" style={{ width: '100%' }} src={previewImage} />
      </Modal>
      <Modal visible={isConfirmVisible} title="결제 확인" footer={null} onCancel={() => setConfirmVisible(false)}>
        <img alt="preview" style={{ width: '100%' }} src={previewImage} />
      </Modal>
    </TaxTemplate>
  );
};

export default TaxNoticeUploadPage;
